// extracted by mini-css-extract-plugin
export default {"rating":"mz-z","numberOfStars":"nz-z","count":"oz-z","barGraphSpacing":"pz-z","barGraph":"qz-z"};